import { InjectionToken } from '@angular/core';

export interface SsrApiTiming {
 method: string;
 path: string;
 durationMs: number;
 status: number;
}

export interface SsrRequestProfile {
 apiRequests: SsrApiTiming[];
}

// Both values belong to one render. Internal API addresses are never transferred to the browser.
export const SSR_API_BASE_URL = new InjectionToken<string>('SSR_API_BASE_URL');
export const SSR_REQUEST_PROFILE = new InjectionToken<SsrRequestProfile>('SSR_REQUEST_PROFILE');

export function normalizeSsrApiBaseUrl(value?: string): string | undefined {
 if (!value?.trim()) return undefined;

 const url = new URL(value.trim());
 if (
  !['http:', 'https:'].includes(url.protocol) ||
  url.username ||
  url.password ||
  url.search ||
  url.hash
 ) {
  throw new Error(
   'SSR_API_BASE_URL must be an HTTP(S) base URL without credentials, query or fragment'
  );
 }
 url.pathname = url.pathname.replace(/\/+$/, '') + '/';
 return url.toString();
}
